import { CHECKBOX_LABEL, FIELD, SELECTION_TITLE } from "./constants";

const TABLE = "IMITEM";

/**
 * The one group reproduces the legacy form's bottom-left group box (grpBottomLeft in uWMD0120.dfm) and
 * its caption band (hdrBottomLeft), which holds exactly the three purge checkboxes.
 *
 * Field order is the DFM's visual and tab order — Item (Top 43, TabOrder 0), Lot (Top 65, TabOrder 1),
 * Sublot (Top 87, TabOrder 2) — not the order the DFM happens to declare them in.
 *
 * "type": "checkbox" for all three, matching the Delphi controls. They are genuinely a three-way level
 * selector (checking Item force-checks and disables the other two, and MainAction only ever emits one
 * DELETE), and a dropdown would arguably say that better — but the checkbox cascade is what users know,
 * and it is what was asked for. The cascade itself lives in the page's handleFieldChange, because the
 * dynamic form has no way to express "this field forces that one".
 *
 * required: false on all three. Fields.js emits a static RequiredRule for a checkbox as a CustomRule
 * demanding `=== true`, which would make every box individually mandatory — the opposite of a
 * selector. The real rule is "at least one, in a valid cascade", enforced in the page's validate() and
 * again server-side in ValidateRequest.
 *
 * tableName is IMITEM because the dynamic form wants one and this screen's own table varies by level;
 * it only matters for the Localization lookup, which isLabelChanged bypasses anyway.
 *
 * isLabelChanged: true so Fields.js uses the literal caption rather than a Localization lookup — these
 * must match the Delphi form and no localization keys exist for them.
 */
const ParametersLayout = [
    {
        groupId: 1,
        label: SELECTION_TITLE,
        fields: [
            {
                name: FIELD.PurgeItems,
                tableName: TABLE,
                label: CHECKBOX_LABEL.PurgeItems,
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.PurgeLots,
                tableName: TABLE,
                label: CHECKBOX_LABEL.PurgeLots,
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.PurgeSublots,
                tableName: TABLE,
                label: CHECKBOX_LABEL.PurgeSublots,
                type: "checkbox",
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { ParametersLayout };
